export default "__VITE_ASSET__9HO7K28u__"